(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ifg-promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ifg-promo-popup')) {
    customElements.define('ifg-promo-popup', class extends HTMLElement {
      connectedCallback() {
        this.component = this.querySelector('dialog-component');
        this.dialog = this.querySelector('dialog');
        this.key = `ifg-promo:${this.dataset.sectionId}:${this.dataset.campaign}`;
        this.onClose = () => { if (!this.editorOpen) this.remember(); this.editorOpen = false; };
        this.onSelect = event => { if (event.detail.sectionId === this.dataset.sectionId) { clearTimeout(this.timer); this.editorOpen = true; this.open(); } };
        this.onDeselect = event => { if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.component.closeDialog(); };
        this.component.addEventListener('dialog:close', this.onClose);
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        if (this.allowed()) this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.component.removeEventListener('dialog:close', this.onClose); document.removeEventListener('shopify:section:select', this.onSelect); document.removeEventListener('shopify:section:deselect', this.onDeselect); if (this.dialog.open) this.component.closeDialog(); }
      // Menu orari in Europe/Rome, indipendentemente dal fuso del visitatore.
      // Il minuto di fine è inclusivo: 23:59 significa fino alle 00:00 escluse.
      romeTimestamp(prefix) {
        if (this.dataset[`${prefix}Enabled`] !== 'true') return null;
        const year = Number(this.dataset[`${prefix}Year`]);
        const month = Number(this.dataset[`${prefix}Month`]);
        const day = Number(this.dataset[`${prefix}Day`]);
        const hour = Number(this.dataset[`${prefix}Hour`]);
        const minute = Number(this.dataset[`${prefix}Minute`]);
        if (![year, month, day, hour, minute].every(Number.isInteger) ||
            year < 2026 || month < 1 || month > 12 || day < 1 || day > 31 ||
            hour < 0 || hour > 23 || minute < 0 || minute > 59) return NaN;
        const wallClock = Date.UTC(year, month - 1, day, hour, minute);
        const check = new Date(wallClock);
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 ||
            check.getUTCDate() !== day) return NaN;
        const fmt = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit',
          day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        });
        const candidates = [60, 120].map(offsetMinutes => wallClock - offsetMinutes * 60000);
        const matches = candidates.filter(timestamp => {
          const parts = Object.fromEntries(fmt.formatToParts(new Date(timestamp))
            .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
          return parts.year === year && parts.month === month && parts.day === day &&
            parts.hour === hour && parts.minute === minute;
        });
        return matches.length ? Math.min(...matches) : NaN;
      }
      allowed() {
        const start = this.romeTimestamp('start');
        const endMinute = this.romeTimestamp('end');
        const end = endMinute === null || Number.isNaN(endMinute) ? endMinute : endMinute + 60000;
        const now = Date.now();
        if (Number.isNaN(start) || Number.isNaN(end) ||
            (start !== null && end !== null && start >= end)) return false;
        if ((start !== null && now < start) || (end !== null && now >= end)) return false;
        try {
          const storage = this.dataset.frequency === 'session' ? sessionStorage : localStorage;
          const last = Number(storage.getItem(this.key) || 0);
          if (this.dataset.frequency === 'session' && last) return false;
          if (this.dataset.frequency === 'day' && now - last < 86400000) return false;
        } catch (_) {}
        return true;
      }
      remember() { try { if (this.dataset.frequency === 'session') sessionStorage.setItem(this.key, String(Date.now())); if (this.dataset.frequency === 'day') localStorage.setItem(this.key, String(Date.now())); } catch (_) {} }
      async open() { await customElements.whenDefined('dialog-component'); if (this.isConnected && !this.dialog.open) this.component.showDialog(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
